module.exports = __webpack_public_path__ + "img/exclusive_feature_01.0e8ba983.jpg";